const LoaderInLine = ({ show }) => {
    return (
        <div className="loader-inline-container" style={!show ? { display: 'none' } : {}}>
            <div className="loader"></div>
        </div>
    );
}

export default LoaderInLine;